import { useEffect, useState } from "react";
import { message } from "antd";
import { useDispatch, useSelector } from "react-redux";

import EntityTable from "../components/EntityTable";
import AddDriverModal from "../components/modals/AddDriverModal";
import {
  fetch,
  remove,
  activate,
  deactivate,
} from "../store/actions/drivers-actions";
import bookingsAPI from "../API/endpoints/bookings";

export default function ManageDrivers() {
  const [isAddDriverModalOpen, setIsAddDriverModalOpen] = useState();

  const dispatch = useDispatch();

  const [messageApi, contextHolder] = message.useMessage();
  const drivers = useSelector((state) => state.drivers.items);

  useEffect(() => {
    dispatch(fetch());
  }, [dispatch]);

  const toggleAddDriverModal = () => {
    setIsAddDriverModalOpen((prev) => !prev);
  };

  const handleDriverAdded = () => {
    messageApi.open({
      type: "success",
      content: "Driver has been added successfully",
    });
    toggleAddDriverModal();
  };

  const checkIfDriverHasBooking = async (id) => {
    const bookings = await bookingsAPI.get({ driver: id });
    const hasBookings = bookings.data.content.length;
    if (hasBookings) {
      throw new Error("This driver has bookings");
    }
  };

  const handleRemoveDriver = async (id, toggleDeleteModal) => {
    try {
      await checkIfDriverHasBooking(id);
      await dispatch(remove(id));
      toggleDeleteModal();
    } catch (error) {
      messageApi.open({
        type: "error",
        content:
          error.message ||
          error.response?.data?.detail ||
          "Error removing driver",
      });
    }
  };

  const handleChangeStatus = async (
    { id = null, active },
    toggleActivateModal
  ) => {
    try {
      active ? await dispatch(deactivate(id)) : await dispatch(activate(id));
      toggleActivateModal();
    } catch (error) {
      messageApi.open({
        type: "error",
        content: error.response?.data?.detail || "Error changing driver status",
      });
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Surname",
      dataIndex: "surname",
      key: "surname",
    },
    {
      title: "Phone",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Driver License Number",
      dataIndex: "driverLicence",
      key: "driverLicence",
    },
    {
      title: "Vehicle Type",
      dataIndex: "type",
      key: "type",
      render: (type) => type.join(", "),
    },
  ];

  const data = drivers.map((driver, index) => ({ ...driver, key: index }));

  return (
    <>
      {contextHolder}
      <EntityTable
        entity="driver"
        columns={columns}
        data={data}
        onAddRow={toggleAddDriverModal}
        onDeleteRow={handleRemoveDriver}
        onChangeStatus={handleChangeStatus}
      />
      <AddDriverModal
        open={isAddDriverModalOpen}
        onClose={toggleAddDriverModal}
        onDriverAdded={handleDriverAdded}
      />
    </>
  );
}
